import styled, {css} from "styled-components"

interface LoginCardProps {
  withBottomPanel?: boolean
  withImage?: boolean
}

export default styled.div<LoginCardProps>`
  ${({theme, withBottomPanel, withImage}) => css`
    background: ${theme.colors.greys.white};
    border-radius: ${withBottomPanel ? `${theme.spacing.one} ${theme.spacing.one} 0 0` : theme.spacing.one};
    display: flex;
    flex-direction: column;

    padding: ${withImage ? theme.spacing.eight : theme.spacing.three} ${theme.spacing.three} ${theme.spacing.five} ${theme.spacing.three};
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: ${withImage ? theme.spacing.eight : theme.spacing.five} ${theme.spacing.five} ${theme.spacing.five} ${theme.spacing.five};
    `}
  `}
`
